export const PROFILE = {
  name: 'Gerry Holmes, CPA',
  headline:
    'Global Finance Executive | Board Member & Audit Committee Candidate | US Head of Finance, Bank of Ireland',
  subHeadline:
    '20+ years driving capital optimization, regulatory remediation, and enterprise finance transformation for Tier-1 global institutions — JPMorgan Chase, Deutsche Bank, Bank of Ireland, and MUFG.',
  location: 'New York City Metropolitan Area',
  email: 'gerry.holmes@boardinquiries.com',
  linkedin: 'https://www.linkedin.com/in/gerryholmes',
  portrait:
    'https://cdn.magicpatterns.com/uploads/85c9RyuVNCAi8zevxpmnzj/gerry_my_frined-Picsart-AiImageEnhancer.jpg',
  architecture:
    'https://cdn.magicpatterns.com/patterns/generated-images/0a013e58-bdb1-4a49-939d-67f4cefb7e76.jpg',
  facade:
    'https://cdn.magicpatterns.com/patterns/generated-images/0c755f20-389e-49b8-b1f6-1297ddf969b0.jpg',
  cpaLicense: 'NY State License #114833-1',
}

export type SectionLink = {
  index: string
  label: string
  navLabel: string
  to: string
  summary: string
}

export const SECTIONS: SectionLink[] = [
  {
    index: '01',
    label: 'About',
    navLabel: 'About',
    to: '/about',
    summary:
      'Executive biography, leadership philosophy, and the profile of a finance leader built inside globally systemic banks.',
  },
  {
    index: '02',
    label: 'Experiences',
    navLabel: 'Experiences',
    to: '/experiences',
    summary:
      'Institutional footprint and career chronology across nine Tier-1 banks and five global financial centers.',
  },
  {
    index: '03',
    label: 'Skills',
    navLabel: 'Skills',
    to: '/skills',
    summary:
      'Functional finance capability inventory — regulatory reporting, financial control, treasury, and leadership disciplines.',
  },
  {
    index: '04',
    label: 'Executive Hero & Board Positioning',
    navLabel: 'Board Positioning',
    to: '/',
    summary:
      'Board candidacy positioning statement: name, mandate, the seats sought, and how to request the board bio.',
  },
  {
    index: '05',
    label: 'Executive Impact & Capital Metrics Grid',
    navLabel: 'Impact Metrics',
    to: '/impact',
    summary:
      'The four quantified outcomes that define the record: $24B capital unlocked, 88 MRAs remediated, $4.3M saved, 20+ years.',
  },
  {
    index: '06',
    label: 'Strategic Value Proposition & Board Competencies',
    navLabel: 'Board Competencies',
    to: '/board-competencies',
    summary:
      'The three governance pillars offered to a board: audit & risk leadership, capital governance, and modernization.',
  },
  {
    index: '07',
    label: 'Executive Career Track Record',
    navLabel: 'Track Record',
    to: '/track-record',
    summary:
      'Role-by-role mandates and deliverables at Bank of Ireland, MUFG, JPMorgan Chase, Deutsche Bank, and earlier.',
  },
  {
    index: '08',
    label: 'Technical Mastery & Systems Portfolio',
    navLabel: 'Systems Portfolio',
    to: '/systems',
    summary:
      'Enterprise platforms, automation tooling, accounting frameworks, and regulatory report forms owned end to end.',
  },
  {
    index: '09',
    label: 'Board Experience, Education & Civic Leadership',
    navLabel: 'Governance & Education',
    to: '/governance',
    summary:
      'Current nonprofit board seats, fiduciary service, university education, and professional credentials.',
  },
  {
    index: '10',
    label: 'Board Inquiry & Direct Contact Portal',
    navLabel: 'Contact',
    to: '/contact',
    summary:
      'Confidential inquiry portal for nominating committees and search firms, plus direct email and LinkedIn.',
  },
]
